import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import CoachProgramsFilterBar from './CoachProgramsFilterBar'
import CoachProgramsList from './CoachProgramsList'
import { selectFilteredCategory, selectFiltersNumber } from '../../../reducers/groupProgramsReducer'
import NoPrograms from './EmptyProgramsList'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

const CoachProgramsFutureTab = ({ fetchPrograms }) => {
  const { t } = useTranslation()
  const future = useSelector(state => state.groupPrograms.future)
  const filtersNumber = useSelector(state => selectFiltersNumber(state, future.filters))
  const filteredCategory = useSelector(state => selectFilteredCategory(state, future.filters?.categoryId))
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)

  return (
    <>
      <CoachProgramsFilterBar
        filters={future.filters}
        filteredCategory={filteredCategory}
        filtersNumber={filtersNumber}
        search={future.search}
        tab={'future'}
      />

      {
        future.programs.length > 0 ?
          <CoachProgramsList
            programs={future.programs}
            timezone={timezone}
            hasMore={future.hasMore}
            fetchPrograms={() => fetchPrograms(future, 'future')}
          />
          :
          future.hasMore === false ?
            (filtersNumber > 0 || future.search) ? (
              <NoPrograms
                title={t('programs.common.noProgramsFound')}
                subtitle={t('programs.groups.noMatchClearFilters')}/>
            ) : (
              <NoPrograms
                title={t('programs.groups.coachProgramsFutureTab.noFuturePrograms')}
                subtitle={t('programs.groups.createPrompt')}/>
            ) : (
              <Loader message={t('programs.groups.loadingPrograms')} />
            )
      }
    </>
  )
}

CoachProgramsFutureTab.propTypes = {
  fetchPrograms: PropTypes.func,
}

export default CoachProgramsFutureTab
